import type { Checkpoint } from '~/lib/api/chats';

export interface VersionItem {
  messageId: string;
  label: string;
  createdAt: string;
  hasPreview: boolean;
  kind: string;
}

/** Chronological v-numbers (v1 = oldest), returned newest-first for display. */
export function buildVersionList(checkpoints: Checkpoint[]): VersionItem[] {
  const chronological = [...checkpoints].sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
  );

  return chronological
    .map((c, i) => ({
      messageId: c.messageId,
      label: `v${i + 1}`,
      createdAt: c.createdAt,
      hasPreview: c.hasPreview,
      kind: c.kind,
    }))
    .reverse();
}
